import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  getVdcs(vdcId) {
      return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId )
      .map(
        (res:any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/vdc-card/vdc-card.service.ts